module.exports = __webpack_public_path__ + "img/OrangeEater.ee59b6f0.png";